// System error
export const SYSTEM_INSUFFICIENT_DISK_SPACE = 'disk-space';
export const SYSTEM_INSUFFICIENT_MEMORY = 'out-of-memory';

// Platform Error
export const PLATFORM_AUTHENTICATION_ERROR = 'authentication-error';
export const PLATFORM_BAD_CREDENTIALS = 'bad-credentials';
export const PLATFORM_FAILURE = 'platform-failure';
export const PLATFORM_INTEGRATION_UNAUTHORIZED = 'integration-unauthorized';
export const PLATFORM_NOT_FOUND = 'platform-not-found';
export const PLATFORM_RATE_LIMIT_EXCEEDED = 'rate-limit-exceeded';

// Config Error
export const CONFIG_VALIDATION = 'config-validation';

// Repository Error
export const REPOSITORY_ACCESS_FORBIDDEN = 'forbidden';
export const REPOSITORY_ARCHIVED = 'archived';
export const REPOSITORY_BLOCKED = 'blocked';
export const REPOSITORY_CANNOT_FORK = 'cannot-fork';
export const REPOSITORY_CHANGED = 'repository-changed';
export const REPOSITORY_DISABLED = 'disabled';
export const REPOSITORY_EMPTY = 'empty';
export const REPOSITORY_FORKED = 'fork';
export const REPOSITORY_MIRRORED = 'mirror';
export const REPOSITORY_NOT_FOUND = 'not-found';
export const REPOSITORY_NO_VULNERABILITY = 'no-vulnerability-alerts';
export const REPOSITORY_RENAMED = 'renamed';
export const REPOSITORY_TEMPORARY_ERROR = 'temporary-error';
export const REPOSITORY_UNINITIATED = 'uninitiated';

// Manager Error
export const MANAGER_LOCKFILE_ERROR = 'lockfile-error';
export const MANAGER_NO_PACKAGE_FILES = 'no-package-files';

// Datasource error
export const DATASOURCE_FAILURE = 'registry-failure';

// Worker Error
export const WORKER_FILE_UPDATE_FAILED = 'update-failure';

// Bundler Error
export const BUNDLER_INVALID_CREDENTIALS = 'bundler-credentials';

// Unknown Error
export const UNKNOWN_ERROR = 'unknown-error';
